import "@progress/kendo-theme-default/dist/all.css";
import Loadable from "@react-loadable/revised";
import { ConnectedRouter } from "connected-react-router";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import ReactGA from "react-ga4";
import Loading from "./components/Loading/Loading";
import { ProtectedRoute } from "./components/ProtectedRoute";
import STSComponent from "./components/STSComponent/STSComponent";
import Login from "./routes/Login/Login";
import RSignOn from "./routes/RSignOn/RSignOn";
import ForgotPassword from "./routes/ForgotPassword/ForgotPassword";

ReactGA.initialize("G-J6M388NVT5");

const HomePage = Loadable({
  loader: () => import("./routes/Home/HomeView"),
  loading: Loading,
});

const SponsorReview = Loadable({
  loader: () => import("./routes/SponsorReview/SponsorReview"),
  loading: Loading,
});

const RawBillData = Loadable({
  loader: () => import("./routes/RawBillData/RawBillData"),
  loading: Loading,
});

const RegisterReview = Loadable({
  loader: () => import("./routes/RegisterReview/RegisterReview"),
  loading: Loading,
});

const RegsUrls = Loadable({
  loader: () => import("./routes/RegsUrls/RegsUrls"),
  loading: Loading,
});

const LocalReview = Loadable({
  loader: () => import("./routes/LocalReview/LocalReview"),
  loading: Loading,
});

const ClientLocalities = Loadable({
  loader: () => import("./routes/ClientLocalities/ClientLocalities"),
  loading: Loading,
});

const AgencyEdit = Loadable({
  loader: () => import("./routes/AgencyEdit/AgencyEdit"),
  loading: Loading,
});

const HistoryActionHelpText = Loadable({
  loader: () => import("./routes/HistoryActionHelpText/HistoryActionHelpText"),
  loading: Loading,
});

const MeetingDates = Loadable({
  loader: () => import("./routes/MeetingDates/MeetingDates"),
  loading: Loading,
});

const RegsNewRecordReview = Loadable({
  loader: () => import("./routes/NewRecordReview/Regs/NewRecordReview"),
  loading: Loading,
});

const LegisNewRecordReview = Loadable({
  loader: () => import("./routes/NewRecordReview/Legis/NewRecordReview"),
  loading: Loading,
});

const LegisTrackInternal = Loadable({
  loader: () => import("./routes/LegisTrackInternal/LegisTrackInternal"),
  loading: Loading,
});

const LocalTrackInternal = Loadable({
  loader: () => import("./routes/LocalTrackInternal/LocalTrackInternal"),
  loading: Loading,
});

const RegsTrackInternal = Loadable({
  loader: () => import("./routes/RegsTrackInternal/RegsTrackInternal"),
  loading: Loading,
});

const RegsInjector = Loadable({
  loader: () => import("./routes/RegsInjector/components/RegsInjector"),
  loading: Loading,
});

const StatusReview = Loadable({
  loader: () => import("./routes/StatusReview/StatusReview"),
  loading: Loading,
});

const SSignOn = Loadable({
  loader: () => import("./routes/SSignOn/SSignOn"),
  loading: Loading,
});

// const CurrentLegislation = Loadable({
//   loader: () =>
//     import("../routes/CurrentLegislation/components/CurrentLegislation"),
//   loading: Loading,
// });

const Groupings = Loadable({
  loader: () => import("./routes/Groupings/components/Groupings"),
  loading: Loading,
});

const Highlighter = Loadable({
  loader: () => import("./routes/Highlighter/components/Highlighter"),
  loading: Loading,
});

const AiTool = Loadable({
  loader: () => import("./routes/AiTool/components/AiTool"),
  loading: Loading,
});

const LegislatorData = Loadable({
  loader: () => import("./routes/LegislatorData/LegislatorData"),
  loading: Loading,
});

const LegSessions = Loadable({
  loader: () => import("./routes/LegSessions/components/LegSessions"),
  loading: Loading,
});

class App extends STSComponent {
  render() {
    const { history, auth } = this.props;
    return (
      <ConnectedRouter history={history}>
        <div className="h-100">
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route path="/rsignon" component={RSignOn} />
            <Route path="/forgotpw" component={ForgotPassword} />
            <Route path="/forgotun" component={ForgotPassword} />
            <ProtectedRoute 
              path="/ssignon" 
              body={SSignOn} 
              authData={auth}
            />       
            <ProtectedRoute
              exact
              path="/"
              body={HomePage}
              authData={auth}
            />
            <ProtectedRoute
              exact
              path="/sponsorreview"
              body={SponsorReview}
              authData={auth}
            />
            <ProtectedRoute
              exact
              path="/rawbilldata"
              body={RawBillData}
              authData={auth}
            />
            <ProtectedRoute
              exact
              path="/registerreview"
              body={RegisterReview}
              authData={auth}
            />
            <ProtectedRoute
              exact
              path="/localreview"
              body={LocalReview}
              authData={auth}
            />
            <ProtectedRoute
              exact
              path="/regsurls"
              body={RegsUrls}
              authData={auth}
            />
            <ProtectedRoute
              exact
              path="/clientlocalities"
              body={ClientLocalities}
              authData={auth}
            />
            <ProtectedRoute
              exact
              path="/agencyedit"
              body={AgencyEdit}
              authData={auth}
            />
            <ProtectedRoute
              exact
              path="/historyhelptext"
              body={HistoryActionHelpText}
              authData={auth}
            />
            <ProtectedRoute
              exact
              path="/meetingdates"
              body={MeetingDates}
              authData={auth}
            />
            <ProtectedRoute
              exact
              path="/regsnewrecordreview"
              body={RegsNewRecordReview}
              authData={auth}
            />
            <ProtectedRoute
              path="/legisnewrecordreview"
              body={LegisNewRecordReview}
              authData={auth}
            />
            <ProtectedRoute
              path="/legistrackinternal"
              body={LegisTrackInternal}
              authData={auth}
            />
            <ProtectedRoute
              path="/statusreview"
              body={StatusReview}
              authData={auth}
            />
            <ProtectedRoute
              path="/localtrackinternal"
              body={LocalTrackInternal}
              authData={auth}
            />
            <ProtectedRoute
              path="/regstrackinternal"
              body={RegsTrackInternal}
              authData={auth}
            />
            <ProtectedRoute
              path="/regsinjector"
              body={RegsInjector}
              authData={auth}
            />
            <ProtectedRoute
              path="/groupings"
              body={Groupings}
              authData={auth}
            />
            <ProtectedRoute
              path="/highlighter"
              body={Highlighter}
              authData={auth}
            />
            <ProtectedRoute
              exact
              path="/aitool"
              body={AiTool}
              authData={auth}
            />
            <ProtectedRoute
              exact
              path="/legislatordata"
              body={LegislatorData}
              authData={auth}
            />
            <ProtectedRoute
              exact
              path="/legsessions"
              body={LegSessions}
              authData={auth}
            />
          </Switch>
        </div>
      </ConnectedRouter>
    );
  }

  static propTypes = {
    history: PropTypes.object,
    auth: PropTypes.object,
  };
}

export default connect(
  (state) => ({
    auth: state.auth,
  }),
  { }
)(App);



// WEBPACK FOOTER //
// ./src/App.js